// components/CTASection.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function CTASection() {
    return (
        <section className="py-20 bg-indigo-900 text-white">
            <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
                <h2 className="text-3xl md:text-5xl font-bold mb-6">
                    Take Control of Your Business Finances Today
                </h2>
                <p className="text-xl mb-10 text-indigo-100">
                    Join thousands of Nigerian businesses already saving time and staying compliant with Arxis Accounting.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link to="/start">
                        <button className="px-10 py-4 bg-white text-indigo-900 font-semibold text-lg rounded-lg hover:bg-gray-100 transition shadow-lg">
                            Start Your Free Trial Now
                        </button>
                    </Link>
                    {/* <Link to="/contact-sales">
                        <button className="px-10 py-4 border-2 border-white font-semibold text-lg rounded-lg hover:bg-white hover:text-indigo-900 transition">
                            Schedule a Demo
                        </button>
                    </Link> */}
                </div>
                <p className="mt-8 text-indigo-200">
                    No credit card required • 14-day free trial • Cancel anytime
                </p>
            </div>
        </section>
    );
}